import { useEffect, useState } from "react";
import PageMeta from "../../components/common/PageMeta";
import MuiTabs from "../../components/Mui/Tabs/Tabs";
import ContainerBox from "../../plugins/components/container";
import { useForm, FieldError } from "react-hook-form";
import { useAxios } from "../../utils/useAxios";
import { MyInput } from "../../components/formFields/MyInput";

const AccountDrivers = () => {
  const [sampleReportData, setSampleReportData] = useState<any | null>(null);

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    watch,
  } = useForm({
    mode: "onSubmit",
  });

  const { res, mutate, isPending, error } = useAxios({
    url: "/api/auth/getReport",
  });

  const onSubmit = (data: any) => {
    mutate(
      {
        formId: "drivers",
        getReport: "driverreports",
        formData: data,
      },
      {
        onSuccess: (res: any) => {
          setSampleReportData(res?.data?.data);
        },
      },
    );
  };

  return (
    <>
      <PageMeta title="TTM Add Drivers | Admin Drivers" description="" />

      <ContainerBox title={"Drivers Accounting"} actions={<></>}>
        <div className="mb-3">
          <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
            <div className={`grid grid-cols-3 gap-0`}>
              <div>
                {/* <MyInput
                  name="email"
                  register={register}
                  error={errors["email"] as FieldError | undefined}
                  placeholder="Enter Email address"
                  type="text"
                /> */}
              </div>
              <div>
                <button
                  type="submit"
                  className=" bg-indigo-500 px-6 py-1.5 text-white font-medium hover:bg-indigo-700"
                >
                  {isPending ? "Submitting" : "Search"}
                </button>
              </div>
            </div>
          </form>
        </div>
        {sampleReportData && <MuiTabs />}
      </ContainerBox>
    </>
  );
};

export default AccountDrivers;
